module.exports = __webpack_public_path__ + "devops-2-039356bd9410fdbb2afc7e612b7310e8.webp";